import React, {useEffect, useState} from 'react';
import '../Setzliste.css';
import ApiService from "../services/ApiService";
import NavbarAltersklassen from "../components/NavbarAltersklassen";

function Ab10mAEinzelwertung() {
    const [loading, setLoading] = useState(false);
    const [altersklassenList, setAltersklassenList] = useState([]);

    const [selectedAltersklasse, setSelectedAltersklasse] = useState(null);
    const [einzelwertungList, setEinzelwertungList] = useState(null);

    const handleKlasseClick = (selectedAltersklasse) => {
        setSelectedAltersklasse(selectedAltersklasse);
        ApiService.fetchEinzelwertung("AB10ma", 2026, selectedAltersklasse)
            .then(data => {
                setEinzelwertungList(data);
            })
            .catch(error => console.error('Fehler beim Laden der Daten für die rechte Spalte:', error));
    };

    useEffect(() => {
        setLoading(true);
        ApiService.fetchAltersklassen("AB10ma")
            .then(data => {
                setAltersklassenList(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Altersklassen:', error));
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="element-content element-background">
            <div className="grid-show-liste">
                <div className="top-panel-liste">
                    <NavbarAltersklassen altersklassenList={altersklassenList}
                                         handleAltersklassenClick={handleKlasseClick}
                                         selectedAltersklasse={selectedAltersklasse}>
                    </NavbarAltersklassen>
                </div>
                <div className="body-panel-liste">
                    {einzelwertungList && (
                        <table className="liste-tabelle">
                            <thead>
                            <tr>
                                <th>Platz</th>
                                <th>Nachname</th>
                                <th>Vorname</th>
                                <th>Verein</th>
                                <th>DG 1</th>
                                <th>DG 2</th>
                                <th>DG 3</th>
                                <th>DG 4</th>
                                <th>DG 5</th>
                                <th>DG 6</th>
                                <th>Durchschnitt</th>
                            </tr>
                            </thead>
                            <tbody>
                            {einzelwertungList.map((entry, index) => (
                                <tr key={`${entry.nachname}-${entry.vorname}-${index}`} className={index % 2 === 0 ? 'even' : 'odd'}>
                                    <td data-label="Platz">{index + 1}</td>
                                    <td data-label="Nachname">{entry.nachname}</td>
                                    <td data-label="Vorname">{entry.vorname}</td>
                                    <td data-label="Verein">{entry.verein}</td>
                                    <td data-label="DG 1">{entry.durchgang1 || '-'}</td>
                                    <td data-label="DG 2">{entry.durchgang2 || '-'}</td>
                                    <td data-label="DG 3">{entry.durchgang3 || '-'}</td>
                                    <td data-label="DG 4">{entry.durchgang4 || '-'}</td>
                                    <td data-label="DG 5">{entry.durchgang5 || '-'}</td>
                                    <td data-label="DG 6">{entry.durchgang6 || '-'}</td>
                                    <td data-label="Durchschnitt">{entry.avg}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Ab10mAEinzelwertung;
